import _MoreVerticalIcon from "@adsk/alloy-react-icon/es/lib/MoreVerticalIcon";
import _MoreHorizontalIcon from "@adsk/alloy-react-icon/es/lib/MoreHorizontalIcon";
const _excluded = ["targetProps", "show", "handleToggle", "className", "style", "disabled", "horizontal", "onClick"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import Button from '@adsk/alloy-react-button';
import theme from '@adsk/alloy-react-theme';
const ActionButtonControl = _ref => {
  let {
      targetProps,
      show,
      handleToggle,
      className,
      style,
      disabled,
      horizontal,
      onClick
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Button, _extends({
    className: className,
    disabled: disabled,
    renderIcon: p => horizontal ? /*#__PURE__*/React.createElement(_MoreHorizontalIcon, p) : /*#__PURE__*/React.createElement(_MoreVerticalIcon, p),
    onClick: function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      onClick === null || onClick === void 0 ? void 0 : onClick(...args);
      handleToggle();
    },
    style: [{
      backgroundColor: show ? theme.tokens.colors.background.neutral.selected.value : theme.tokens.colors.background.primary.value
    }, disabled && {
      '&:active': {
        borderColor: theme.tokens.colors.border.inactive.value
      }
    }, style]
  }, props, targetProps));
};
export default ActionButtonControl;
//# sourceMappingURL=Control.js.map